module.exports = {
    methods: {
        setErrors(error) {
            if (error.response.status === 422) {
                return error.response.data.errors
            }

            return {}
        }
    }
};
